import React from 'react'
import { TopBarStyle } from './TopBar.styled';
import ROUTE from '../../common/Routes';
import { useNavigate } from 'react-router-dom';

const TopBar2 = () => {
const navigate=useNavigate();
  return (
    <TopBarStyle>
    <div
      className='top-container2'
    >
      <div className='container-2' onClick={()=>navigate(ROUTE.Home)}>
        <img src={`${process.env.PUBLIC_URL}/headerLogo.svg`} alt="Logo" className='logo2' /> 
      </div>
      
      </div>
    </TopBarStyle>
  );
}

export default TopBar2